import * as React from 'react';
import { isSameDay } from 'date-fns';
import { useFocus } from '../../../contexts';
/** Handle the focus for the day element. */
export function useDayFocus(date, buttonRef) {
    var _a = useFocus(), focusedDay = _a[0], _b = _a[1], focusDayAfter = _b.focusDayAfter, focusDayBefore = _b.focusDayBefore, focusWeekAfterDay = _b.focusWeekAfterDay, focusWeekBeforeDay = _b.focusWeekBeforeDay, blur = _b.blur, focus = _b.focus;
    // Focus the HTML element if this is the focused day.
    React.useEffect(function () {
        var _a;
        if (!focusedDay)
            return;
        if (isSameDay(focusedDay, date)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [focusedDay]);
    var focusOnKeyDown = function (e) {
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfterDay();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBeforeDay();
                break;
        }
    };
    var isFocused = Boolean(focusedDay && !isSameDay(focusedDay, date));
    return { focus: focus, blur: blur, focusOnKeyDown: focusOnKeyDown, isFocused: isFocused };
}
//# sourceMappingURL=useDayFocus.js.map